import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import priceFormatter from "../../../utils/helpers/price-formatter";
import ChatIcon from "./images/chat.svg";

const PostInspectionDiyPreviousOffer = ({
    previousOfferedPrice,
    showMsg = true,
    msg = "You will receive a message (SMS/ WhatsApp) when we have an update for you",
    children,
    isExpiredOffer = false
}) => {

    return (
        <React.Fragment>
            {
                !!previousOfferedPrice &&
                <div styleName={`${isExpiredOffer ? "styles.expiredOffer" : "styles.previousOffer"}`}>
                    <p>Expired offer:</p>
                    <span>₹{priceFormatter(previousOfferedPrice)}</span>
                </div>
            }
            { children && children }
            {
                showMsg &&
                <div styleName={"styles.chatWrapper"}>
                    <img src={ChatIcon} alt="chat" />
                    {msg}
                </div>
            }
        </React.Fragment>
    );
};

PostInspectionDiyPreviousOffer.propTypes = {
    previousOfferedPrice: PropTypes.object,
    showMsg: PropTypes.bool,
    msg: PropTypes.string,
    children: PropTypes.any,
    isExpiredOffer: PropTypes.bool
};

export default PostInspectionDiyPreviousOffer;
